var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacilityIcon12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394",
    transform: "translate(-1305 -2627)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(1305 2627)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8_bed",
    d: "M7.25,4a3.472,3.472,0,0,0-3.5,3.444v9.089A3.418,3.418,0,0,0,2,19.5V35H5.5V31.556h28V35H37V19.5a3.419,3.419,0,0,0-1.75-2.967V7.444A3.472,3.472,0,0,0,31.75,4Zm0,3.444h24.5v8.611H30V12.611a1.737,1.737,0,0,0-1.75-1.722H23a1.737,1.737,0,0,0-1.75,1.722v3.444h-3.5V12.611A1.737,1.737,0,0,0,16,10.889H10.75A1.737,1.737,0,0,0,9,12.611v3.444H7.25ZM5.5,19.5h28v8.611H5.5Z",
    transform: "translate(1325.5 2647.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilityIcon12);
export default __webpack_public_path__ + "static/media/facilityIcon12.2493a7ce64d40c6f89cb8e2720f8a180.svg";
export { ForwardRef as ReactComponent };